import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ComponentsRoutes } from './components.routing';
import { ListViewComponent } from './list-view/list-view.component';
import { FormViewComponent } from './form-view/form-view.component';
import { PipesModule } from '../pipes/pipes.module';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';
import { CadastroDialogComponent } from './cadastro-dialog/cadastro-dialog.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingComponent } from './loading/loading.component';
import { MaterialModule } from '../material.module';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { ImagemComponent } from './imagem/imagem.component';
import { SelecaoDataComponent } from './selecao-data/selecao-data.component';
import { SelectItemComponent } from './select-item/select-item.component';
import { DataPickerComponent } from './data-picker/data-picker.component';
import { CalendarioPickerComponent } from './calendario-picker/calendario-picker.component';
import { CheckboxComponent } from './checkbox/checkbox.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ComponentsRoutes),
    FormsModule,
    MaterialModule,
    PipesModule,
    NgxSpinnerModule,
    ReactiveFormsModule
  ],
  declarations: [
    ListViewComponent,
    FormViewComponent,
    PopupDialogComponent,
    CadastroDialogComponent,
    LoadingComponent,
    AutoCompleteComponent,
    ImagemComponent,
    SelecaoDataComponent,
    SelectItemComponent,
    DataPickerComponent,
    CalendarioPickerComponent,
    CheckboxComponent,
  ],
  exports:[
    ListViewComponent,
    FormViewComponent,
    PopupDialogComponent,
    LoadingComponent,
    AutoCompleteComponent,
    ImagemComponent,
    SelecaoDataComponent,
    SelectItemComponent,
    DataPickerComponent,
    CalendarioPickerComponent,
    CheckboxComponent,
  ],
  entryComponents:[
    ListViewComponent,
    FormViewComponent,
    PopupDialogComponent,
    LoadingComponent,
    AutoCompleteComponent,
    CalendarioPickerComponent,
  ]
})

export class ComponentsModule {}
